import { Config, s3UploaderFolderName } from '@nw/shared/config';

const FILE_EXTENSION_CONTENT_TYPE_MAP: Record<string, string> = {
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  png: 'image/png',
  pdf: 'application/pdf'
};

export const getS3UploadContentType = (file: File): string => {
  if (file.type) {
    return file.type;
  }

  const extension = getFileExtension(file.name, '');
  return (
    FILE_EXTENSION_CONTENT_TYPE_MAP[extension.toLowerCase()] ??
    'application/octet-stream'
  );
};

export const getFileExtension = (fileName: string, fileType: string): string =>
  (fileName && fileName.slice(((fileName.lastIndexOf('.') - 1) >>> 0) + 2)) ||
  (fileType && fileType.slice(((fileType.lastIndexOf('/') - 1) >>> 0) + 2));

export const getFileNameFromS3Url = (s3Url: string): string => {
  const lastIndexOfSlash = s3Url.lastIndexOf('/');
  const nameOfTheFile = s3Url.substring(lastIndexOfSlash + 1, s3Url.length);
  return nameOfTheFile;
};

export const getS3FileUploaderUrl = (value: string) => {
  const { profilePic } = s3UploaderFolderName;
  const updatedUrl = value.replace(profilePic, `${Config.ENVIRONMENT}/media/`);

  return updatedUrl;
};
